/* Veyra · tienda · 2026-08-19, ampliado el 2026-08-20
   Lo unico que el CSS no puede hacer: el precio vivo y el stepper de cantidad.

   Las pestañas NO estan aqui: son radios + CSS. Un tab que necesita JS deja de
   funcionar si el script falla; uno hecho con :checked no.

   Desde el 2026-10-05 el producto tiene DOS ejes —sabor y periodo— y desde el
   2026-10-06 el sabor se cambia aqui mismo, sin navegar: ver el bloque
   «EL SABOR CAMBIA EN SU SITIO» mas abajo. */
(function () {
  'use strict';

  var quieto = window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- El precio dejaba de teleportarse · 2026-09-01 ----------------------
     `textContent =` reemplazaba de golpe el numero que sostiene la decision de
     compra. El puente NO puede costar latencia: el valor nuevo se escribe YA y
     el pulso ocurre encima, sobre el numero correcto. Al reves —fundir a cero,
     escribir, fundir a uno— el precio parpadea y tarda mas en leerse.
     180 ms y la curva del sistema. Con el movimiento apagado, no hay pulso: el
     numero sigue cambiando, que es lo unico que de verdad importa.
     ---------------------------------------------------------------------- */
  function pulso(el) {
    if (quieto || !el || !el.animate) return;
    el.animate([
      { opacity: .25, transform: 'translateY(3px)' },
      { opacity: 1,   transform: 'none' }
    ], { duration: 180, easing: 'cubic-bezier(.2,.8,.2,1)' });
  }

  var formas = document.querySelectorAll('[data-vy-forma]');

  Array.prototype.forEach.call(formas, function (forma) {
    /* --- precio vivo ------------------------------------------------------ */
    var salida = forma.querySelector('[data-vy-precio]');
    var unidad = forma.querySelector('[data-vy-unidad]');
    var primera = true;
    function pintar() {
      var elegido = forma.querySelector('input[name="id"]:checked');
      if (!elegido || !salida) return;
      var nuevo = elegido.getAttribute('data-precio') || salida.textContent;
      // Solo pulsa si el numero CAMBIO, y nunca en la pintada de arranque: un
      // pulso al cargar la pagina es un parpadeo sin causa.
      var cambio = !primera && nuevo !== salida.textContent;
      primera = false;
      salida.textContent = nuevo;
      if (unidad) unidad.textContent = elegido.getAttribute('data-unidad') || '';
      if (cambio) { pulso(salida); pulso(unidad); }
    }
    /* POR DELEGACION, no radio por radio: al cambiar de sabor las tarjetas de
       periodo se reemplazan enteras, y un listener puesto en un radio se va con
       el radio. El formulario no se reemplaza nunca. */
    forma.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') pintar();
    });
    if (forma.querySelector('input[name="id"]')) pintar();

    /* --- stepper de cantidad ---------------------------------------------- */
    var campo = forma.querySelector('input[name="quantity"]');
    if (!campo) return;
    var minimo = parseInt(campo.getAttribute('min'), 10) || 1;
    var maximo = parseInt(campo.getAttribute('max'), 10) || 99;

    Array.prototype.forEach.call(forma.querySelectorAll('[data-vy-cant]'), function (b) {
      b.addEventListener('click', function () {
        var paso = parseInt(b.getAttribute('data-vy-cant'), 10);
        var n = parseInt(campo.value, 10);
        if (isNaN(n)) n = minimo;
        campo.value = Math.min(maximo, Math.max(minimo, n + paso));
        limites();
      });
    });

    // Tambien se puede teclear: hay que sanear lo que quede escrito.
    campo.addEventListener('change', function () {
      var n = parseInt(campo.value, 10);
      campo.value = isNaN(n) ? minimo : Math.min(maximo, Math.max(minimo, n));
      limites();
    });

    function limites() {
      var n = parseInt(campo.value, 10) || minimo;
      Array.prototype.forEach.call(forma.querySelectorAll('[data-vy-cant]'), function (b) {
        var paso = parseInt(b.getAttribute('data-vy-cant'), 10);
        b.disabled = (paso < 0 && n <= minimo) || (paso > 0 && n >= maximo);
      });
    }
    limites();
  });

  /* --- EL SABOR CAMBIA EN SU SITIO · 2026-10-06 ---------------------------
     Braulio: «son dos diferentes productos y solo debe ser uno con dos
     variantes». En Shopify era UN producto; lo que lo hacia parecer dos era que
     la muestra de sabor navegaba a `/products/…?variant=` —desde la home te
     sacaba de la pagina y te dejaba arriba de la ficha—.

     NO HAY `fetch`. La galeria y las tarjetas de periodo de cada sabor ya
     vienen en la pagina, dentro de `<template>` (`vy-galeria-sabores` y
     `vy-caja-compra`); aqui solo se cambia una por otra. Dos motivos:
       · la Section Rendering API no sirve en la home: ahi `?variant=` no marca
         nada (medido: devuelve Cacao pidiendo Vanilla);
       · un `fetch` que falla a mitad deja la foto de un sabor con los ids del
         otro, y eso es comprar lo que no se ve. Sin nada asincrono no hay mitad.

     Se comprueba TODO antes de tocar nada: si falta una sola pieza no se cambia
     a medias, se devuelve `false` y el enlace navega como siempre.
     ---------------------------------------------------------------------- */
  function plantillaDe(raiz, atributo, valor) {
    var ts = raiz.querySelectorAll('template[' + atributo + ']');
    for (var i = 0; i < ts.length; i++) {
      if (ts[i].getAttribute(atributo) === valor && ts[i].content) return ts[i];
    }
    return null;
  }

  function matrizDe(raiz) {
    var nodo = raiz.querySelector('[data-vy-variantes]');
    if (!nodo) return null;
    try { return JSON.parse(nodo.textContent); } catch (err) { return null; }
  }

  /* En la FICHA la URL sigue a la variante, para que recargar o compartir
     conserve el sabor. En la home no se toca: ahi `?variant=` no significa nada. */
  function urlDeVariante(id) {
    if (!id || location.pathname.indexOf('/products/') !== 0) return;
    if (!window.history || !history.replaceState || typeof URL !== 'function') return;
    try {
      var u = new URL(location.href);
      u.searchParams.set('variant', id);
      history.replaceState(history.state, '', u.pathname + u.search + u.hash);
    } catch (err) { /* una URL que no se actualiza no rompe la compra */ }
  }

  /* Mueve el scroll `dy` px SIN animar. El scroller no es siempre el mismo:
     en escritorio es `.page-wrapper` y en telefono el documento (medido el
     2026-08-26), asi que se busca el ancestro que de verdad scrollea. Y Horizon
     pone `scroll-behavior: smooth`: sin `instant` la correccion se veria. */
  function desplazar(el, dy) {
    var n = el.parentElement;
    while (n && n !== document.body && n !== document.documentElement) {
      var o = window.getComputedStyle(n).overflowY;
      if ((o === 'auto' || o === 'scroll') && n.scrollHeight > n.clientHeight + 1) break;
      n = n.parentElement;
    }
    var blanco = (n && n !== document.body && n !== document.documentElement) ? n : window;
    try { blanco.scrollBy({ top: dy, left: 0, behavior: 'instant' }); }
    catch (err) { blanco.scrollBy(0, dy); }
  }

  function cambiarSabor(a) {
    var raiz  = a.closest('.vy-producto');
    var grupo = a.closest('[data-vy-sabores]');
    var forma = raiz && raiz.querySelector('[data-vy-forma]');
    if (!raiz || !grupo || !forma) return false;

    var sabor  = a.getAttribute('data-vy-sabor');
    var vivas  = forma.querySelector('[data-vy-planes]');
    var tPlan  = plantillaDe(raiz, 'data-vy-planes-sabor', sabor);
    var col    = raiz.querySelector('[data-vy-gal-col]');
    var tGal   = plantillaDe(raiz, 'data-vy-gal-sabor', sabor);
    var oculto = forma.querySelector('[data-vy-id]');
    var una    = null;

    // --- todo lo que puede faltar se mira ANTES de mover un solo nodo ---------
    if (col && !tGal) return false;
    if (vivas) {
      if (!tPlan || !tPlan.content.querySelector('[data-vy-planes] input[name="id"]')) return false;
    } else {
      // Producto con sabor y sin periodo: el id y el precio salen de la matriz.
      var matriz = matrizDe(raiz) || [];
      for (var i = 0; i < matriz.length; i++) {
        if (matriz[i].opciones.indexOf(sabor) !== -1 && matriz[i].disponible) { una = matriz[i]; break; }
      }
      if (!una || !oculto) return false;
    }

    /* DONDE ESTABA LA MUESTRA antes de mover nada. La foto de cada sabor no mide
       lo mismo (Cacao 1:1, Vanilla 4:5) y en telefono la galeria va ENCIMA del
       selector: al cambiar, todo lo de abajo baja 85 px. Chrome lo compensa
       solo (scroll anchoring); Safari no, y la muestra se iria de debajo del
       dedo. Se mide antes y despues y se devuelve la diferencia. */
    var topAntes = a.getBoundingClientRect().top;

    // --- las tarjetas de periodo: se conserva el periodo que estaba elegido ---
    if (vivas) {
      var antes = vivas.querySelector('input[name="id"]:checked');
      var plan  = antes ? antes.getAttribute('data-vy-plan') : null;
      var nuevas = tPlan.content.querySelector('[data-vy-planes]').cloneNode(true);
      var marcar = null;
      Array.prototype.forEach.call(nuevas.querySelectorAll('input[name="id"]'), function (r) {
        r.checked = false;
        r.removeAttribute('checked');
        if (r.disabled) return;
        if (r.getAttribute('data-vy-plan') === plan) marcar = r;
      });
      if (!marcar) marcar = nuevas.querySelector('input[name="id"]:not([disabled])');
      vivas.parentNode.replaceChild(nuevas, vivas);
      if (marcar) marcar.checked = true;
    } else {
      oculto.value = una.id;
      var cifra = forma.querySelector('[data-vy-precio]');
      if (cifra && una.precio_txt) { cifra.textContent = una.precio_txt; pulso(cifra); }
    }

    // --- la galeria: fuera lo que no sea plantilla, dentro la de este sabor ---
    if (col) {
      var primera = null;
      Array.prototype.forEach.call(Array.prototype.slice.call(col.children), function (h) {
        if (h.tagName === 'TEMPLATE') { primera = primera || h; } else { col.removeChild(h); }
      });
      var copia  = tGal.content.cloneNode(true);
      var piezas = Array.prototype.slice.call(copia.children);
      /* La lamina marcada entra a la vista YA: se pide sin `lazy`. */
      var rVisto = copia.querySelector('.vy-gal__r[checked]');
      var iVisto = rVisto
        ? copia.querySelector('.vy-gal__foto[data-g="' + rVisto.id.split('-').pop() + '"] img')
        : copia.querySelector('img');
      if (iVisto) iVisto.setAttribute('loading', 'eager');
      col.insertBefore(copia, primera);
      if (!quieto) {
        piezas.forEach(function (el) {
          if (el.animate) el.animate([{ opacity: .35 }, { opacity: 1 }],
            { duration: 200, easing: 'cubic-bezier(.2,.8,.2,1)' });
        });
      }
    }

    // --- las muestras y el nombre -------------------------------------------
    Array.prototype.forEach.call(grupo.querySelectorAll('[data-vy-sabor]'), function (b) {
      var on = b === a;
      b.classList.toggle('vy-sabor-m--on', on);
      if (on) { b.setAttribute('aria-current', 'true'); } else { b.removeAttribute('aria-current'); }
    });
    var nombre = grupo.querySelector('[data-vy-sabor-nombre]');
    if (nombre) { nombre.textContent = sabor; pulso(nombre); }

    var salto = a.getBoundingClientRect().top - topAntes;
    if (Math.abs(salto) > 1) desplazar(a, salto);

    var elegido = forma.querySelector('input[name="id"]:checked') || oculto;
    urlDeVariante(elegido && elegido.value);
    return true;
  }

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[data-vy-sabor]');
    if (!a) return;
    // ⌘-clic, clic central y compañia: que abra la ficha en otra pestaña.
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    // Tocar el sabor que ya esta puesto no lleva a ningun lado.
    if (a.classList.contains('vy-sabor-m--on')) { e.preventDefault(); return; }
    if (cambiarSabor(a)) e.preventDefault();
  });

  /* El periodo tambien mueve la URL de la ficha: lo que dice la barra de
     direcciones es lo que esta marcado. */
  document.addEventListener('change', function (e) {
    var r = e.target;
    if (r && r.name === 'id' && r.type === 'radio' && r.closest && r.closest('[data-vy-forma]')) {
      urlDeVariante(r.value);
    }
  });

  /* LA FOTO DEL OTRO SABOR SE PRECARGA AL ACERCARSE, no al cargar la pagina:
     quien nunca cambia de sabor no paga esos bytes, y quien va a cambiar la
     tiene lista cuando suelta el dedo. Se copia `srcset` y `sizes` para que el
     navegador pida el MISMO candidato que va a pintar, no el original. */
  function precargar(a) {
    if (a.getAttribute('data-vy-pre')) return;
    a.setAttribute('data-vy-pre', '1');
    var raiz = a.closest('.vy-producto');
    var t = raiz && plantillaDe(raiz, 'data-vy-gal-sabor', a.getAttribute('data-vy-sabor'));
    if (!t) return;
    var radio = t.content.querySelector('.vy-gal__r[checked]');
    var img = radio
      ? t.content.querySelector('.vy-gal__foto[data-g="' + radio.id.split('-').pop() + '"] img')
      : null;
    img = img || t.content.querySelector('img');
    if (!img || !img.getAttribute('src')) return;
    var pre = new Image();
    if (img.getAttribute('sizes'))  pre.sizes  = img.getAttribute('sizes');
    if (img.getAttribute('srcset')) pre.srcset = img.getAttribute('srcset');
    pre.src = img.getAttribute('src');
  }
  ['mouseover', 'touchstart', 'focusin'].forEach(function (evento) {
    document.addEventListener(evento, function (e) {
      var a = e.target && e.target.closest && e.target.closest('a[data-vy-sabor]');
      if (a && !a.classList.contains('vy-sabor-m--on')) precargar(a);
    }, { passive: true });
  });

  /* --- barra de compra fija ----------------------------------------------
     Se enciende cuando el hero sale de pantalla. Con IntersectionObserver y no
     con un umbral de scroll en px: un numero fijo funciona en un ancho y falla
     en todos los demas, porque el hero no mide lo mismo en movil que en
     escritorio. Traducido de los position:sticky de gruns (2026-08-20). */
  var fija = document.querySelector('[data-vy-fija]');
  if (fija) {
    var ancla = document.querySelector('.vy-ht') ||   /* hero tipo Tueste (2026-10-07) */
                document.querySelector('.vy-hero') ||
                document.querySelector('.vy-producto') ||
                document.querySelector('.vy-banda');
    if (ancla && 'IntersectionObserver' in window) {
      fija.removeAttribute('hidden');
      /* vyFijaEstado (2026-10-08): la barra se ve SOLO si el hero ya pasó y NO estamos en la caja
         de compra ni en el footer. Antes cada observador decidía por su cuenta y el del hero podía
         volver a encenderla encima de la leyenda COFEPRIS. */
      var vyFijaEstado = { hero: true, caja: false, pie: false };
      var vyFijaPinta = function () { fija.classList.toggle('vy-fija--vista', !vyFijaEstado.hero && !vyFijaEstado.caja && !vyFijaEstado.pie); };
      new IntersectionObserver(function (entradas) {
        vyFijaEstado.hero = entradas[0].isIntersecting; vyFijaPinta();
      }, { rootMargin: '-120px 0px 0px 0px' }).observe(ancla);
    }
    // Si ya estas en la seccion de compra, la barra estorba en vez de ayudar.
    var caja = document.querySelector('#comprar, .vy-producto');
    if (caja && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        if (typeof vyFijaEstado !== 'undefined') { vyFijaEstado.caja = e[0].intersectionRatio >= 0.35; vyFijaPinta(); }
        else if (e[0].isIntersecting) fija.classList.remove('vy-fija--vista');
      }, { threshold: [0, 0.35] }).observe(caja);
    }
    /* Y SOBRE EL FOOTER TAMBIEN SE RETIRA, que no es cosmetico: en telefono la
       barra vive abajo y mide ~68 px, justo encima de la leyenda COFEPRIS —que
       es obligatoria y tiene que estar VISIBLE, no tapada por cromo propio.
       Medido el 2026-08-21 en la pasada de movil. El padding del footer reserva
       el hueco ademas, por si el observador no llega. */
    var pie = document.querySelector('.vy-pie') || document.querySelector('.vy-footer');
    if (pie && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        if (typeof vyFijaEstado !== 'undefined') { vyFijaEstado.pie = e[0].intersectionRatio > 0; vyFijaPinta(); }
        else if (e[0].isIntersecting) fija.classList.remove('vy-fija--vista');
      }, { threshold: [0, 0.01] }).observe(pie);
    }
  }

  /* --- spinner del boton de agregar --------------------------------------
     Adaptado de `spin` + `pulse` de gruns, que es lo unico funcional de su
     familia dorada. Hasta hoy pulsar "Apartar mi bolsa" no devolvia nada hasta
     que la pagina cambiaba: en una conexion lenta son segundos sin senal, y la
     gente vuelve a pulsar. El boton se bloquea solo, asi que tambien evita el
     doble envio. */
  Array.prototype.forEach.call(document.querySelectorAll('[data-vy-forma]'), function (forma) {
    forma.addEventListener('submit', function () {
      var boton = forma.querySelector('button[type="submit"]');
      if (!boton) return;
      boton.classList.add('vy-btn--cargando');
      boton.setAttribute('aria-busy', 'true');
      // Si el navegador vuelve atras con la pagina en cache, el boton seguiria
      // bloqueado y no habria forma de comprar. Se desbloquea al restaurarla.
      window.addEventListener('pageshow', function () {
        boton.classList.remove('vy-btn--cargando');
        boton.removeAttribute('aria-busy');
      });
    });
  });

  /* --- El riel de fuentes dice cuanto queda · 2026-09-09 ------------------
     En telefono la banda de fuentes es un riel deslizable (CSS puro, ver
     veyra.css § TELEFONO · LA REJA PASA A RIEL). El gesto NO depende de este
     bloque: sin JS el riel se desliza igual y no se pierde un solo logo. Lo
     unico que hay aqui es el filete que dice por donde va el dedo.

     No son puntos de paginacion a proposito: no es interactivo, asi que no hay
     un objetivo tactil de 44 px que cumplir ni un target que falle.

     Vive en `veyra-tienda.js` y no en `veyra-motion.js` porque ese archivo hace
     `return` entero con `prefers-reduced-motion`, y esto no es movimiento: es
     saber cuanto queda.
     --------------------------------------------------------------------- */
  (function () {
    var riel  = document.querySelector('.vy-fuentes__fila');
    var barra = document.querySelector('[data-vy-riel]');
    if (!riel || !barra) return;
    var pulgar = barra.querySelector('.vy-fuentes__pulgar');
    if (!pulgar) return;

    var pedido = 0;

    function pintar() {
      pedido = 0;
      var largo = riel.scrollWidth;
      var visto = riel.clientWidth;
      /* Cuatro px de tolerancia: el subpixel del zoom del navegador deja
         `scrollWidth` por encima de `clientWidth` por decimas sin que haya
         nada que deslizar, y el filete apareceria en escritorio. */
      if (largo <= visto + 4) {
        barra.hidden = true;
        return;
      }
      barra.hidden = false;
      var razon  = visto / largo;
      var avance = riel.scrollLeft / (largo - visto);
      if (avance < 0) { avance = 0; }
      if (avance > 1) { avance = 1; }
      pulgar.style.transform = 'translateX(' +
        (avance * (1 - razon) * barra.clientWidth) + 'px) scaleX(' + razon + ')';
    }

    function pedir() {
      if (pedido) { return; }
      pedido = requestAnimationFrame(pintar);
    }

    riel.addEventListener('scroll', pedir, { passive: true });
    window.addEventListener('resize', pedir);
    /* Los logos llegan tarde y tres de los cuatro son SVG: hasta que cargan,
       `scrollWidth` es el de las cajas sin contenido y el filete sale de un
       ancho que no le toca. Se remide al final de la carga. */
    window.addEventListener('load', pedir);
    pintar();
  })();
})();
